/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { ChangeEventHandler } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Place = {
  name: string;
  placeCode: string;
};

type Props = {
  onFulfillmentSelect: (placeCode: Place["placeCode"]) => void;
  places: Place[];
  selectedPlaceCode: Place["placeCode"];
};

export const FulfillmentSelect: FcWithoutChildren<Props> = (props) => {
  const { onFulfillmentSelect, places, selectedPlaceCode } = props;
  const handleChange: ChangeEventHandler<HTMLSelectElement> = (event) => {
    onFulfillmentSelect(event.currentTarget.value);
  };

  return (
    <div>
      {/* TODO: 多言語対応 */}
      <h3 css={heading3Style}>受け取り場所</h3>

      <select
        css={selectStyle}
        defaultValue={selectedPlaceCode}
        onChange={handleChange}
      >
        {/* TODO: デフォの初期値は持てないのでデザイン・仕様確認 */}
        {places.map((place) => {
          const { name, placeCode } = place;

          return (
            <option key={placeCode} value={placeCode}>
              {name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

const heading3Style = css`
  font-weight: 700;
`;

const selectStyle = css`
  border: 1px solid #000;
  border-radius: 10px;
  width: 100%;
`;
